import { Component, OnInit ,Input} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {Cliente} from '../../../models/cliente';
import {Cotizacion} from '../../../models/cotizacion';
import {generalService} from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import {MatDialog} from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-cotizacion-addedit',
  styles: [],
  templateUrl: 'cotizacionAddEdit.component.html',
  providers: [generalService]
})

export class CotizacionAddEditComponent implements OnInit {
 
 @Input() cotizacion:Cotizacion;
 @Input() cliente:Cliente;
  cotizacionAgregar: FormGroup;
  titulo = "Agregar";
  list: any;
  cliente_id: string;


  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private route: ActivatedRoute) { 
    this.cotizacion = new Cotizacion();
    this.cliente = new Cliente();
    this.dataService.guardado=false;
    this.list = new Object;
    this.cliente_id = (this.route.snapshot.paramMap.get('id'));  }

  ngOnInit() {
    this.buildForm();
      this.getInit(this.dataService.idCliente);

      if(this.dataService.tipo == "editar"){
        this.titulo = "Editar";
        this.cotizacion.idCotizacion = this.dataService.id;
        this.buscarCotizacion(this.cotizacion.idCotizacion);
      }
  }

    getInit(id:any){
      this._generalService.metodoCall(`cotizacion/getInit/${id}`).subscribe(
          result => {            
            let res = JSON.parse(result);
            
            this.cliente.Nombre = res.Table[0].nombre;
            
            // this.list.State = res.Table3;
            // this.list.City = res.Table4;
            },
          error => {
            console.log(<any>error);
          }
        );
    }

  buscarCotizacion(id:any){
      this._generalService.metodoCall(`cotizacion/consultarCotizacionId/${id}`).subscribe(
        result => {
          this.cotizacion = JSON.parse(result.replace("[", "").replace("]", ""));     

           
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  buildForm() {
    this.cotizacionAgregar = this.formBuilder.group({
      clienteNombre: this.formBuilder.control(null,),
          monto: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      comentario: this.formBuilder.control(null,[Validators.required, Validators.maxLength(250)])
  
    
    });
    this.cotizacionAgregar.get('clienteNombre').disable();
  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  onSubmit() {
      let metodo = "cotizacion/agregarCotizacion";
      if(this.dataService.tipo == "editar"){
        metodo = "cotizacion/actualizarCotizacion";
      }
      this.cotizacion.idCliente = this.dataService.idCliente;
     
      this._generalService.metodoCallParams(this.cotizacion, metodo).subscribe(
          result => {
            this.dataService.guardado=true;
            this.cerrarModal();
          },
          error => {
            var errorMsj = <any>error;
            console.log(errorMsj);
          }
      ); 
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/cotizacion/agregar-editar/cotizacionAddEdit.component.ts